import { parseBytesContent } from "../../../utils/general";
import { ConversationServiceClient } from "../../clients/ConversationServiceClient";
import { IntToMessageTypeConstants, MessageTypeConstants } from "../Message";



export const getPaginatedArchiveMessages = async (conversation, startTime, fetchDirection) => {
    let botId = conversation?.bot?.botId || "im-bot";
    let conversationId = conversation?.chatConversationId || conversation.conversationId
  
    return ConversationServiceClient.fetchPaginatedArchiveMessage(
      conversationId,
      botId,
      startTime,
      fetchDirection
    ).then((data) => {
      let messages = data?.content || [];
      let out = [];
      messages.forEach((message) => {
        out.push(convertArchivedMessageToWebMessage(message));
      });
      return { messages: out, messages2: messages, moreMessagesExist: data?.moreMessagesExist };
    });
  };
  
  
  const convertArchivedMessageToWebMessage = (message) => {
    let type = IntToMessageTypeConstants[message.contentType];
  
    if (type === MessageTypeConstants.MESSAGE_TYPE_MAP) {
    }
  
    message.content = parseBytesContent(message.content);
    message.options = parseBytesContent(message.options);
  
    let out = {
      messageType: type,
      message: type === "string" ? message.content[0] : message.content,
      createdBy: message.createdBy,
      createdOn: message.createdOn,
      messageId: message.messageId,
      options: message.options,
      archived: true,
      isDeleted: message.isDeleted,
      isDelivered: message.isDelivered,
      isOpened: message.isOpened,
    };
    if (type === MessageTypeConstants.MESSAGE_TYPE_FORM_RESPONSE) {
      out.options = out.options || {};
      out.options.stage = "COMPLETED";
    }
    return out;
  };